import axios from 'axios'
import { castAttributesForCamelCase } from '../../../../modules/string_converter'

export const companiesStoreGmbMetadata = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
  },
  mutations: {
    prepareApi(state) {
      state.loading = true
    },
    prepareConnect(state) {
      state.data = null
      state.loading = true
    },
    readStoreGmbMetadataSuccess(state, payload) {
      if (payload.data) {
        state.data = castAttributesForCamelCase(payload.data)
      }
      state.loading = false
    },
    readStoreGmbMetadataFailure(state) {
      state.loading = false
    },
  },
  getters: {
    canModifyServiceList(state){
      if (state.data == null) return false

      return state.data.canModifyServiceList
    },
    canHaveFoodMenus(state){
      if (state.data == null) return false

      return state.data.canHaveFoodMenus
    },
  },
  actions: {
    readStoreGmbMetadata({ commit, rootState }, storeUuid) {
      commit('prepareConnect')
      return axios
        .get(`/api/companies/${ rootState.route.params.company_uuid }/stores/${ storeUuid }/gmb/metadata.json`)
        .then(res => {
          commit('readStoreGmbMetadataSuccess', res.data)
        })
        .catch(err => {
          commit('readStoreGmbMetadataFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    }
  }
}
